import { Card, Typography } from "@mui/material";
import React from "react";
import { styles } from "../styles/styles";
import { DecorativeCorner } from "../common/DecorativeCorner";

function AcheivementSection() {
	return (
		<div>
			<Card sx={{...styles.whyuse
}}>
				<DecorativeCorner
					sx={{ top: -20, left: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ top: -20, right: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }}
				/>
				<DecorativeCorner
					sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }}
				/>

				<Typography variant="h4" component="div" sx={styles.specialText}>
					We, at Annapurna Marriages, are{" "}
					<span style={{ color: "#b38533" }}>100% committed to finding</span>
				</Typography>
				<Typography variant="h4" component="div" sx={styles.specialText}>
					you with your{" "}
					<span style={{ color: "#b38533" }}>Dream Life partner</span>
				</Typography>

				<Typography
					variant="h5"
					component="div"
					sx={{ ...styles.specialText, mt: 4 }}
				>
					So far, We have{" "}
					<span style={{ color: "#b38533" }}>10,00,000+ Happy Customers</span>{" "}
					on our
				</Typography>
				<Typography variant="h5" component="div" sx={styles.specialText}>
					platform across the world
				</Typography>
			</Card>
		</div>
	);
}

export default AcheivementSection;
